import { getApplicationImage, newSessionUID, APPFACTOR } from "./commons";
import { Button } from "@mui/material"; 
import { useState } from "react";
import { ShieldProxy } from "./Scan.js";

const NameValue = ({ name, value, ml, mt = 6, fs }) => {
  const fontSize = fs ? fs : 13;
  return (
    <div style={{
      marginTop: mt,
      ...(ml ? { marginLeft: ml, marginTop: mt } : {}),
    }}>
      <div 
      title={name}
      style={{
        display: "inline-block",
        textAlign: "right",
        minWidth: 67,
        fontSize: fontSize,
        opacity: 0.5,
      }}>
      { name } 
      </div>
      <div 
      title={value.length > 43 ?  value:""}
      style={{
        display: "inline-block",
        marginLeft: 8,
        fontSize: fontSize,
        textWrap: "wrap",
        lineHeight: 1.5,
      }}>
        {value.length > 43 ? value.substring(0,43) + "..." : value}
      </div>
    </div>
  )
}

export function RepoItem({ setOpenEditIndexPage,hide = false, m, i, isDarkMode, showIndexButton = true, showDeleteButton = false , refreshDataSources=()=>{} , startScan =()=>{} , setDoneProgress =()=>{} , dataSourcesList=[], gData={},setActiveRepoName}) {
  let isOverride = (m?.http_client_settings !== undefined && m?.http_client_settings != null && m.http_client_settings?.http_proxy == null);

  const [visibleDeleteButton, setVisibleDeleteButton] = useState(false);
  
  
  const repoName = `repoItem_${m.name}`;
  
  return (
    <>
  <div
  className={repoName}
  onMouseEnter={() => setVisibleDeleteButton(true)}
  onMouseLeave={() => setVisibleDeleteButton(false)}
      style={{
        position: "relative",
        flex: 1,
        padding: 10,
        paddingTop: 14,
        borderRadius: 8,
        backgroundColor: isDarkMode ? "rgba(6,6,6,1)" : "rgba(255,255,255,0.5)",
        border: isDarkMode ? "1px solid rgba(255,255,255,0)" : "0.42px solid rgba(0,0,0,0.1)",
        height: 100,
        paddingLeft: 80,
        minWidth: 342,
        minHeight: 140,
      }}
      key={`indexRepo_${i}`}>

        {isOverride && <div 
        title="Override proxy - disabled"
        style={{
          position: "absolute",
          top: 6,
          right: 10,
          filter: `drop-shadow(0px 0px 2.42px ${isDarkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)"})`
        }}
        >
        <ShieldProxy color="rgba(127,26,7,1)" chatText="D"/>
        </div>}
        {(visibleDeleteButton && showDeleteButton) && 
        <>
       
        <div 
        className={`editButton`}
        style={{
          position: "absolute",
          top: 10,
          right: 46,
          padding:2,
          textAlign: "center",
          width: 130,
          border:"1px solid rgba(255,255,255,0.2)",
          borderRadius: 4,
          minWidth: 62,
          maxWidth: 62,
          maxHeight: 62,
          fontSize: 10,
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          var yes = confirm(`Are you sure you want to delete "${m.title || m.name}" data source?`);
          if (yes) {

            window.postMessage(
              JSON.stringify(
                {
                  type: APPFACTOR.command,
                  scanRaw: true,
                  payload: {
                    "type": "delete_data_source",
                    "id": newSessionUID(),
                    "data_source_name": m.title || m.name
                  },
                })
            );

            setTimeout(() => {
             refreshDataSources();
            }, 500);
          }
        }}
        >DELETE</div>
        
        <div
        className={`editButton`}

         style={{
          position: "absolute",
          top: 10,
          right: 120,
          borderRadius: 4,
          padding:2,
          textAlign: "center",
          width: 110,
          border:"1px solid rgba(255,255,255,0.2)",
          minWidth: 42,
          maxWidth: 42,
          maxHeight: 42,
          fontSize: 10,
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          setActiveRepoName(m.name);
          setOpenEditIndexPage(true);
        }}
        >EDIT</div>

        </>
        }

      <div style={{
        width: "64px",
        height: "64px",
        borderRadius: 8,
        position: "absolute",
        backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(224,224,224,1)",
        top: 24,
        left: 24,
        border: "1px solid rgba(255,255,255,0.20)",
      }}>
        {m.type && <div
          className="arepoLink"
          style={{
            position: "absolute",
            marginTop: 6,
            marginLeft: 6,
            width: 50,
            height: 50,
            minWidth: 30,
            minHeight: 30,
            borderRadius: "99em",
            backgroundColor: isDarkMode ? "rgba(4,4,4,0)" : "rgba(24,24,24,1)",
            backgroundSize: "46px 46px",
            backgroundPosition: "2px 2px",
            backgroundRepeat: "no-repeat",
            fontSize: 10,
            color: "rgba(255,255,255,0.5)",
            backgroundImage: `url(${getApplicationImage(
              m.type, "AppComponent",
              isDarkMode
            )})`
          }}
        ></div>}

      </div>
      {/* <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 8 }}>&nbsp;{m.title || m.name}</div> */}
      <div  style={{ fontSize: 4, fontWeight: 600, marginBottom: 8 }}>&nbsp;</div>
      <NameValue name="Name" value={m.title || m.name}></NameValue>
      <NameValue name="Type" value={m.type}></NameValue>
      {m.username ? <NameValue name="User" value={m.username}></NameValue>:<div>&nbsp;</div>}

      {showIndexButton ? <Button
        style={{
          opacity: hide ? 0 : 1,
          pointerEvents: hide ? "none" : "auto",
          // backgroundColor: isDarkMode ? "rgba(255,255,255,0.042)" : "rgba(0,0,0,0.142)",
          color: isDarkMode ? "rgba(255,255,255,0.75)" : "rgba(0,0,0,0.5)",
          fontSize: 14,
          marginTop: 25,
          marginLeft: -56,
          maxWidth: 64,
          minWidth: 64,
          maxHeight: 32,
          minHeight: 22,
          padding: "4px !important",
          borderRadius: 4,
          border: isDarkMode ? "1px solid rgba(42,42,42,1)" : "1px solid rgba(0,0,0,0.142)",
        }}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();

          setDoneProgress({});
          startScan( [m]);
        }}>INDEX </Button>:<><br/></>}
      <NameValue 
      // ml={-22}
       mt={-26}
      fs={11} 
      name="URL" value={<div
        style={{
          textDecoration: "underline",
          textDecorationColor: "rgba(255,255,255,0.2)",
          cursor: "pointer",
          opacity: 0.9,
        }}
        onClick={() => {
          window.open(m.url, "_blank");
        }}>{m.url}</div>}></NameValue>

    </div>

    </>
    )
}


